import React, { useCallback } from 'react'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import ToggleButton from 'components/Luxkit/ToggleButton'

const facilityCategoryIconMap: Record<string, App.OfferFeatureSymbol> = {
  dining: 'crossed_utensils',
  entertainment: 'tv',
  wellness: 'lotus',
  family: 'childs_face',
  activities: 'pool',
  bars: 'martini_glass',
  shopping: 'tag',
  technology: 'internet_connection',
  accommodation: 'bed',
  enrichment: 'line_university',
  specifications: 'line_ship',
  services: 'line_key_skeleton',
  other: 'check',
}

interface Props {
  amenityInfo: App.CruiseShipAmenityInfo;
  isSelected: boolean;
  onSelect: (amenityInfo: App.CruiseShipAmenityInfo) => void;
}

function CruiseShipAmenitiesTab({
  amenityInfo,
  isSelected,
  onSelect,
}: Props) {
  const { title, category } = amenityInfo
  const iconName = facilityCategoryIconMap[category || 'other']
  const Icon = getOfferFeatureIcon(iconName)

  const handleTabClick = useCallback(() => {
    onSelect(amenityInfo)
  }, [onSelect, amenityInfo])

  return <ToggleButton
    key={`tab-amenity-${title}`}
    data-option={title}
    kind="primary"
    startIcon={<Icon />}
    title={title}
    orientation="vertical"
    isSelected={isSelected}
    onClick={handleTabClick}
  />
}

export default CruiseShipAmenitiesTab
